import { render, staticRenderFns } from "./IcoDevelopmentPlan.vue?vue&type=template&id=2a4ccf98"
import script from "./IcoDevelopmentPlan.vue?vue&type=script&lang=js"
export * from "./IcoDevelopmentPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports